import { prefix } from "../../design-tokens/meta";

export const componentName = "Select";

export const componentClasses = {
    basic: `${prefix}select`,
    placeholder: `${prefix}select--placeholder`,
    wrapper: `${prefix}select__wrapper`,
    field: `${prefix}select__field`,
    optionPlaceholder: `${prefix}select__option--placeholder`,
    helperText: `${prefix}select__helper`,
    chevronIcon: `${prefix}select__chevron`,
    feedbackIcon: `${prefix}select__feedback__icon`,
    errorText: `${prefix}invalid-feedback`,
    sizes: {
        sm: `${prefix}select--sm`,
        lg: ``, // Default size does not implement class
    },
};

export const views = {
    select: {
        size: {
            sm: {
                classList: [`${componentClasses.sizes.sm}`],
            },
            lg: {
                classList: [`!${componentClasses.sizes.sm}`],
            },
        },
    },
    field: {
        standard: {
            classList: [`!${componentClasses.placeholder}`],
        },
        placeholder: {
            classList: [`${componentClasses.placeholder}`],
        },
    },
};
